import { Cancel as CancelIcon, Done as DoneIcon } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { memo, ReactNode, type JSX } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  onCancel: () => void
  onConfirm: () => void
  title: string | ReactNode
  children?: ReactNode
  open: boolean
  disabled?: boolean
}

const ActionsDialog = ({ onCancel, onConfirm, title, children, open, disabled = false }: Props): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Dialog
      onClose={onCancel}
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
      keepMounted
      transitionDuration={0}
      disablePortal
    >
      <DialogTitle style={{ borderBottom: '1px solid' }} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button variant="contained" color="warning" startIcon={<CancelIcon />} onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button disabled={disabled} onClick={onConfirm} variant="contained" color="success" startIcon={<DoneIcon />}>
          {t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(ActionsDialog)
